<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="justify-center mt-3">
          <v-col cols="3">
            <v-autocomplete
              v-model="form.filters.nome"
              :items="form.lists.nomesDasFuncoes"
              label="Função"
              outlined
              maxlength="40"
              dense
            ></v-autocomplete>
          </v-col>
          <v-col cols="3">
            <v-select
              v-model="form.filters.tipo"
              label="Tipo da Função"
              :items="form.lists.tipos"
              item-text="descricao"
              item-value="id"
              outlined
              dense
            ></v-select>
          </v-col>
          <sigfoco-select-ativo
            :cols="3"
            v-model="form.filters.ativo"
            labelType="Situação"
          ></sigfoco-select-ativo>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarFuncoes()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Incluir"
              icon="mdi-plus"
              @click="openDialogManterFuncao()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
      >
        <template v-slot:[`item.ativo`]="{ item }">
          <sigfoco-label-ativo-inativo :ativo="item.ativo"></sigfoco-label-ativo-inativo>
        </template>
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            text="Visualizar"
            icon="mdi-eye-outline"
            small
            @click="openDialogVisualizarFuncao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Editar"
            icon="mdi-pencil"
            small
            @click="openDialogManterFuncao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Excluir"
            icon="mdi-delete"
            small
            @click="excluirFuncao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            :text="`${item.ativo ? 'Inativar' : 'Ativar'}`"
            :icon="`${item.ativo ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off'}`"
            :color="`${item.ativo ? 'var(--primary-button-color)' : 'silver'}`"
            small
            @click="alterarStatusFuncao(item)"
          ></sigfoco-tooltip>
        </template>
        <template v-slot:[`item.emUso`]="{ item }">
          <sigfoco-tooltip
            :text="'Detalhar Uso'"
            :icon="item.emUso ? 'mdi-check-circle-outline' : 'mdi-close-circle-outline'"
            :color="item.emUso ? 'green' : 'red'"
            :small="true"
            :disabled="!item.emUso"
            @click="item.emUso ? openDialogDetalharUsoFuncao(item) : null"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <VisualizarFuncaoDialog
      v-if="dialogVisualizarFuncao.visible"
      :visible="dialogVisualizarFuncao.visible"
      :content="dialogVisualizarFuncao.content"
      @onClose="dialogVisualizarFuncao.close()"
    ></VisualizarFuncaoDialog>
    <CadastrarEditarFuncaoDialog
      :tipos="form.lists.tipos"
      :edit="dialogManterFuncao.edit"
      :visible="dialogManterFuncao.visible"
      :content="dialogManterFuncao.content"
      @onClose="dialogManterFuncao.close()"
      @onSave="atualizarListasDeFuncoes()"
    ></CadastrarEditarFuncaoDialog>
    <DetalharUsoFuncaoDialog
      :visible="dialogDetalharUsoFuncao.visible"
      :content="dialogDetalharUsoFuncao.content"
      @onClose="dialogDetalharUsoFuncao.close()"
      ></DetalharUsoFuncaoDialog>
  </div>
</template>

<script>
import { Funcao } from "~/commons/classes/funcao";
import { Dialog } from "~/commons/classes/dialog";
import ManterFuncaoService from "~/services/manter-funcao.service"
import VisualizarFuncaoDialog from "./dialogs/VisualizarFuncaoDialog.vue";
import CadastrarEditarFuncaoDialog from "./dialogs/CadastrarEditarFuncaoDialog.vue";
import DetalharUsoFuncaoDialog from "./dialogs/DetalharUsoFuncaoDialog.vue";
export default {
  name: "ManterFuncoesView",
  mixins: [ManterFuncaoService],
  components: {
    VisualizarFuncaoDialog,
    CadastrarEditarFuncaoDialog,
    DetalharUsoFuncaoDialog
  },
  data: () => ({
    dialogManterFuncao: Dialog.Build(),
    dialogVisualizarFuncao: Dialog.Build(),
    dialogDetalharUsoFuncao: Dialog.Build(),
    form:{
      filters: {
        nome: null,
        tipo: null,
        ativo: null,
      },
      lists: {
        tipos: [],
        nomesDasFuncoes: []
      }
    },
    table: {
      headers: [
        { text: "Função", align: "center", value: "nome" },
        { text: "Tipo da Função", align: "center", value: "tipo" },
        { text: "Situação", align: "center", value: "ativo", sortable: false  },
        { text: "Ações", align: "center", value: "acoes", sortable: false },
        { text: "Em uso", align: "center", value: "emUso", sortable: false },
      ],
      itens: [],
    }
  }),
  methods: {
    atualizarListasDeFuncoes() {
      this.buscarNomeDasFuncoes();
      this.buscarFuncoes();
    },
    buscarNomeDasFuncoes() {
      this.$buscarNomeDasFuncoes().then(
        ({data}) => this.form.lists.nomesDasFuncoes = data.itens
      )
    },
    buscarTipos() {
      this.$buscarTipos().then(
        ({data}) => this.form.lists.tipos = data.itens
      )
    },
    buscarFuncoes() {
      this.$buscarFuncoes({ params: this.form.filters }).then(
        ({ data }) => this.table.itens = data.itens
      )
    },
    resetForm() {
      this.$resetForm();
      this.table.itens = [];
      this.form.filters.ativo = null;
    },
    openDialogManterFuncao(funcao) {
      funcao
        ? this.$visualizarFuncao(funcao.id).then(
          ({ data }) => this.dialogManterFuncao.open(new Funcao(data.resposta), true))
        : this.dialogManterFuncao.open(Funcao.Build());
    },
    openDialogVisualizarFuncao(funcao) {
      this.$visualizarFuncao(funcao.id).then(
        ({ data }) => this.dialogVisualizarFuncao.open(new Funcao(data.resposta))
      );
    },
    excluirFuncao(funcao) {
      this.$swal({
        text: `Deseja confirmar a exclusão da função?`,
        type: "error",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        if(funcao.emUso){
            this.mostrarModalEmUso(funcao);
          } else {
              this.$excluirFuncao(funcao.id).then(({ data }) => {
              this.$notifySuccess(data.mensagem);
              this.buscarFuncoes();
            });
          }
        }
      );
    },
    alterarStatusFuncao(funcao) {
      this.$swal({
        text: `Deseja confirmar a ${ funcao.ativo ? "inativação" : "ativação" } da Função?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
          if(funcao.ativo && funcao.emUso) {
            this.mostrarModalEmUso(funcao);
          } else {
            this.$inativarAtivarFuncao(funcao.id).then(({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.buscarFuncoes();
          });
          }
        }
      );
    },
    mostrarModalEmUso(item) {
      const qtd = item.quantidadeEmUso;
      this.$swal({
        text: `O registro não pode ser inativado ou excluído, pois está em uso em ${qtd} funcionalidade(s).`,
        type: "warning",
        confirmButtonText: "OK",
      });
    },
    openDialogDetalharUsoFuncao(funcao) {
      this.$detalharUsoFuncao(funcao).then(
        ({ data }) => (this.dialogDetalharUsoFuncao.open(data.resposta))
      );
    },
  },
  mounted() {
    this.buscarTipos();
    this.buscarNomeDasFuncoes();
  },
}
</script>